// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerBubble__bubble-cd2785 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: var(--message-bubble-max-width);
  border: none;
  background-color: transparent;
  padding: 0;
  border-radius: unset;
}

.StickerBubble__content-a206c6 {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.StickerBubble__container-cc4670:hover .StickerBubble__status-bar-e5809e {
  opacity: 1;
}

.StickerBubble__status-bar-e5809e {
  position: absolute;
  inset-inline-end: 0px;
  bottom: 0px;
  padding: 2px 6px;
  border-radius: 12px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--addition-50);
  background: var(--average-background);
  transition: opacity 0.15s ease-in-out;
  opacity: 0;
  gap: 4px;
}

.StickerBubble__status-bar-e5809e span {
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--addition-50);
}

.StickerBubble__status-bar-e5809e > svg {
  fill: var(--addition-50);
  color: var(--danger-40);
}

.StickerBubble__comment-e07217 {
  padding: var(--indent-12px) var(--indent-16px);
}

.StickerBubble__comment-text-a117b0 {
  display: inline;
}

.StickerBubble__commented-status-bar-af40b2 {
  float: right;
  margin-top: 6px;
  margin-inline-start: var(--indent-8px);
}

.StickerBubble__views-ae67f6 span {
  color: var(--addition-50);
}

.StickerBubble__views-ae67f6 svg {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/StickerBubble/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,0CAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,6CAAA;EACA,yBAAA;EACA,qCAAA;EACA,qCAAA;EACA,UAAA;EACA,QAAA;AACF;;AAEA;EACE,2BAAA;EACA,6CAAA;EACA,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,uBAAA;AACF;;AAEA;EACE,8CAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".bubble {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  max-width: var(--message-bubble-max-width);\n  border: none;\n  background-color: transparent;\n  padding: 0;\n  border-radius: unset;\n}\n\n.content {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.container:hover .status-bar {\n  opacity: 1;\n}\n\n.status-bar {\n  position: absolute;\n  inset-inline-end: 0px;\n  bottom: 0px;\n  padding: 2px 6px;\n  border-radius: 12px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--addition-50);\n  background: var(--average-background);\n  transition: opacity 0.15s ease-in-out;\n  opacity: 0;\n  gap: 4px;\n}\n\n.status-bar span {\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--addition-50);\n}\n\n.status-bar > svg {\n  fill: var(--addition-50);\n  color: var(--danger-40);\n}\n\n.comment {\n  padding: var(--indent-12px) var(--indent-16px);\n}\n\n.comment-text {\n  display: inline;\n}\n\n.commented-status-bar {\n  float: right;\n  margin-top: 6px;\n  margin-inline-start: var(--indent-8px);\n}\n\n.views span {\n  color: var(--addition-50);\n}\n\n.views svg {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `StickerBubble__bubble-cd2785`,
	"content": `StickerBubble__content-a206c6`,
	"container": `StickerBubble__container-cc4670`,
	"status-bar": `StickerBubble__status-bar-e5809e`,
	"statusBar": `StickerBubble__status-bar-e5809e`,
	"comment": `StickerBubble__comment-e07217`,
	"comment-text": `StickerBubble__comment-text-a117b0`,
	"commentText": `StickerBubble__comment-text-a117b0`,
	"commented-status-bar": `StickerBubble__commented-status-bar-af40b2`,
	"commentedStatusBar": `StickerBubble__commented-status-bar-af40b2`,
	"views": `StickerBubble__views-ae67f6`
};
module.exports = ___CSS_LOADER_EXPORT___;
